import { DIMENSION_TYPES_CONSTANTS } from '@utils/metrics';

export const DIMENSION_POPUP_OK_TEXT = 'Apply';
export const DIMENSION_POPUP_TITLE = 'Select dimensions to view';

export const hasAdDimensions = (dimensionList: string[], dimensionCategories = {}) => {
  return dimensionCategories?.[DIMENSION_TYPES_CONSTANTS.ai]?.some((d) =>
    dimensionList.includes(d.key),
  );
};
